import { Link } from "gatsby";
import React from "react";
import { Icon } from "react-feather";
import styled from "styled-components";

const StyledButton = styled.button`
  ${({ theme }) => theme.mixins.components.button};
`;

const Button = ({
  link,
  name,
  Icon,
}: {
  link: string;
  name?: string;
  Icon?: Icon;
}) => {
  return (
    <Link to={link}>
      <StyledButton>
        {Icon && <Icon />}
        <div>{name}</div>
      </StyledButton>
    </Link>
  );
};

export default Button;
